import React from 'react';
import './styles.css';

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className = '', ...props }, ref) => {
    const labelClasses = `label ${className}`.trim();
    
    return (
      <label 
        className={labelClasses}
        ref={ref}
        {...props}
      />
    );
  }
);

Label.displayName = 'Label';

